import {GridContainer, GridItem} from 'components'
import React, {Component, Suspense} from 'react'
import Cipher from "./Cipher";

const redirigirLogin = () => {
  window.location.href = '/auth/login-page'
};

const LOGOUT_REASON_KEY = 'sessionLogoutReason';

export const setLogoutReason = (reason) => {
  if (!reason) {
    sessionStorage.removeItem(LOGOUT_REASON_KEY);
    return;
  }
  sessionStorage.setItem(LOGOUT_REASON_KEY, reason);
};

export const consumeLogoutReason = () => {
  const reason = sessionStorage.getItem(LOGOUT_REASON_KEY);
  sessionStorage.removeItem(LOGOUT_REASON_KEY);
  return reason;
};

// remove token
export const cerrarSession = (reason = 'manual') => {
  if (reason === 'manual') {
    setLogoutReason(null);
  } else {
    setLogoutReason(reason);
  }
  removeUserSession();
  redirigirLogin();
};



const TOKEN_KEY = 'accessToken';
const TOKEN_REFRESH_KEY = 'refreshToken';

// desencripta de forma segura: si el valor guardado esta corrupto o fue
// cifrado con una llave distinta a la actual, limpia esa entrada en vez de
// tumbar la app (evita el "Malformed UTF-8 data" al intentar loguearse)
const safeDecrypt = (raw, storageKey) => {
  try {
    return Cipher.decrypting(raw);
  } catch (e) {
    console.warn(`Sesion local corrupta en '${storageKey}', se limpia.`, e);
    if (storageKey) localStorage.removeItem(storageKey);
    return null;
  }
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_REFRESH_KEY);
  localStorage.removeItem("sessionRec");
  localStorage.removeItem("sessionComp");
  localStorage.removeItem("sessionSuc");
  localStorage.removeItem("sessionLoc");
  localStorage.removeItem("sessionMens");
}


export const removeUserMenus = () => {
  localStorage.removeItem("sessionComp");
  localStorage.removeItem("sessionSuc");
  localStorage.removeItem("sessionLoc");
  localStorage.removeItem("sessionMens");
}

// set the token and user from the session storage
export const setUserSession = (user) => {
  let userStr = JSON.stringify(user);
  localStorage.setItem("sessionRec", Cipher.encrypting(userStr));
};

// return the user data from the session storage
export const getUser = () => {
  let userStr = localStorage.getItem("sessionRec");
  if (!userStr) return null;
  let plano = safeDecrypt(userStr, "sessionRec");
  if (!plano) return null;
  return JSON.parse(plano);
};

export const setTokenUser = (token) => {
  let valorEncriptado = Cipher.encrypting(token.accessToken);
  let valorEncriptadoRT = Cipher.encrypting(token.refreshToken);
  localStorage.setItem(TOKEN_KEY, valorEncriptado);
  localStorage.setItem(TOKEN_REFRESH_KEY, valorEncriptadoRT);
};

export const setMenusSession = (data) => {
  let userStr = JSON.stringify(data);
  localStorage.setItem("sessionMens", Cipher.encrypting(userStr));
};

export const isLogin = () => {
  return !!localStorage.getItem(TOKEN_KEY) && !!getTokenUser();
};

// return the token from the session storage
export const getToken = iniciarDatos => {
  let tokenUsuario = sessionStorage.getItem('tokenGrc')
  if (tokenUsuario)
    if (tokenUsuario === 'undefined') {
    } else return safeDecrypt(tokenUsuario, 'tokenGrc')
  return null
}

export const getTokenUser = () => {
  let token = localStorage.getItem(TOKEN_KEY);
  let refreshToken = localStorage.getItem(TOKEN_REFRESH_KEY);
  if (!token || !refreshToken) return null;
  let tokenDecrypt = safeDecrypt(token, TOKEN_KEY);
  let tokenRefreshDecrypt = safeDecrypt(refreshToken, TOKEN_REFRESH_KEY);
  if (!tokenDecrypt || !tokenRefreshDecrypt) return null;
  return {
    accessToken: tokenDecrypt,
    refreshToken: tokenRefreshDecrypt
  }
  // return JSON.parse(obj);
};

export const getRole = () => {
  return getUser()?.roles[0];
};

// return the company from the local storage
export const getCompany = () => {
  let userStr = localStorage.getItem("sessionComp");
  if (!userStr) return null;
  let plano = safeDecrypt(userStr, "sessionComp");
  if (!plano) return null;
  return JSON.parse(plano);

};

// return the sucursal from the local storage
export const getSucursal = () => {
  let userStr = localStorage.getItem("sessionSuc");
  if (!userStr) return null;
  let plano = safeDecrypt(userStr, "sessionSuc");
  if (!plano) return null;
  return JSON.parse(plano);

};

// return the sucursal from the local storage
export const getLocal = () => {
  let userStr = localStorage.getItem("sessionLoc");
  if (!userStr) return null;
  let plano = safeDecrypt(userStr, "sessionLoc");
  if (!plano) return null;
  return JSON.parse(plano);

};

// return the menus from the local storage
export const getMenus = () => {
  let userStr = localStorage.getItem("sessionMens");
  if (!userStr) return null;
  let plano = safeDecrypt(userStr, "sessionMens");
  if (!plano) return null;
  return JSON.parse(plano);

};

export const getUsername = () => {
  return getUser()?.username;
}

// set company local storage
export const setCompanySession = (data) => {
  let userStr = JSON.stringify(data);
  localStorage.setItem("sessionComp", Cipher.encrypting(userStr));
};
// set sucursal local storage
export const setSucursalSession = (data) => {
  let userStr = JSON.stringify(data);
  localStorage.setItem("sessionSuc", Cipher.encrypting(userStr));
};
// set local local storage
export const setLocalSession = (data) => {
  let userStr = JSON.stringify(data);
  localStorage.setItem("sessionLoc", Cipher.encrypting(userStr));
};

export const navDynamic = () => {
  let result = [];
  let menus = getMenus() == null ? [] : getMenus();
  console.log('emnus')
  console.log(menus.length)

  if (menus.length === 0) {
    return result;
  } else {
    let obj = {};
    for (let i = 0; i < menus.length; i++) {
      let result1 = [];
      const element1 = menus[i];
      obj = {
        collapse: true,
        name: element1.name,
        rtlName: "صفحات",
        rtlMini: "هعذا",
        icon: element1.icon,
        state: element1.name + "Collapse",
        views: [],
      }

      if (element1.menus && element1.menus.length > 0) {
        let obj2 = {};
        for (let j = 0; j < element1.menus.length; j++) {
          const element2 = element1.menus[j];
          obj2 = {
            path: element2.path,
            name: element2.name,
            rtlName: "صفحات",
            rtlMini: "هعذا",
            mini: null,
            icon: element2.icon,
            component: obtenerComponentePagina(element2.component, {
              acciones: element2.acciones
            }),
            layout: "/admin",
          }
          result1.push(obj2)

        }
        obj.views = result1;
        result.push(obj);
      }
    }
  }
  return result;
}

/**
 * Funcion para obtener las paginas del sistema cargando sus componentes dinamicamente
 *
 */
export const getModuleWithComponent = () => {
  const menu = []
  const subMenu = []
  const subMenuHijo = []
  let datosSesion = getUser()
  if (!datosSesion) return []
  const modulo = getMenus().modulo;
  let modulos = getMenus().pantallasModulo;
  if (modulos && modulos.length > 0) {
    modulos.forEach(function(item) {
      // Agrega el menu generado
      menu.push({
        codigo: item.codigoPantalla,
        path: '/' + item.path.toLowerCase(),
        name: item.name,
        icon: item.icon,
        image: item.image,
        component: obtenerComponentePagina(item.component, {
          acciones: item.acciones
        }),
        pantallasHijas: item.pantallasHijas,
        acciones: item.acciones,
        layout: item.layout
      })
      if (item.pantallasHijas && item.pantallasHijas.length > 0) {
        item.pantallasHijas.forEach(function(itemH) {
          // Agrega el menu generado
          subMenu.push({
            codigo: itemH.codigoPantalla,
            codigoPadre: item.codigoPantalla,
            descripcionPadre: item.component,
            path: '/' + itemH.path.toLowerCase(),
            name: itemH.name,
            icon: itemH.icon,
            image: itemH.image,
            component: obtenerComponentePagina(itemH.component, {
              acciones: itemH.acciones
            }),
            acciones: itemH.acciones,
            layout: itemH.layout
          })

          if (itemH.pantallasHijas && itemH.pantallasHijas.length > 0) {
            itemH.pantallasHijas.forEach(function(itemSH) {
              // Agrega el menu generado
              subMenuHijo.push({
                codigo: itemSH.codigoPantalla,
                codigoPadre: itemH.codigoPantalla,
                path: '/' + itemSH.path.toLowerCase(),
                name: itemSH.name,
                icon: itemSH.icon,
                image: itemSH.image,
                component: obtenerComponentePagina(itemSH.component, {
                  acciones: itemSH.acciones
                }),
                acciones: itemSH.acciones,
                layout: itemSH.layout
              })
            })
          }
        })
      }
    })
  }
  return { menu, subMenu, subMenuHijo, modulo }
}

/**
 * Carga dinamicamente un componente en base a su ruta desde la carpeta views
 * coloca en el props un campo llamado parameters un diccionario con todos los
 * parametros que se requiera usar dentro del componente
 *
 * @param {*} pageName
 */
function obtenerComponentePagina(pageName, parameters) {
  return class GeneralComponent extends Component {
    constructor(props) {
      super(props)
    }
    render() {
      const OtherComponent = React.lazy(() => import(`views/${pageName}.js`))
      if (!parameters) {
        parameters = {}
      }
      return (
          <Suspense
              fallback={
                <div>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <br />
                      <br />
                      <br />
                      {/* <Spinner size={35} loading={true} /> */}
                    </GridItem>
                  </GridContainer>
                </div>
              }
          >
            <OtherComponent parameters={parameters} />
          </Suspense>
      )
    }
  }
}

export const verificaAccion = (acciones, action) => {
  if (!acciones) return false;
  let datos = acciones.filter(function (item) {
    return item.nombre === action;
  });
  return !!(datos && datos.length > 0);

}

export const ACCIONES_PANTALLA = {
  BUSCAR: 'F',
  LEER: 'R',
  MODIFICAR: 'U',
  NUEVO: 'C',
  ELIMINAR: 'D',
  DESCARGAR: 'DE',
  CONTABILIZAR:'CO',
  IMPRIMIR: 'P',
  PDF:'V'
}
